import { render, staticRenderFns } from "./clueCirculationRecord.vue?vue&type=template&id=10ccb64e&scoped=true"
import script from "./clueCirculationRecord.vue?vue&type=script&lang=js"
export * from "./clueCirculationRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ccb64e",
  null
  
)

export default component.exports